import { PayloadAction } from '@reduxjs/toolkit';
import { IExchangeItem, IPlayerSearchResult } from '~/rage';
import { IListItem } from '../../components/ListItem';
import { createSlice } from '../wrappers';

const initialState = {
	selectedPlayer: null as IPlayerSearchResult | null,
	tabIndex: 0,
	tabsCount: 3,
	playerOffer: [] as IExchangeItem[],
	propertyList: [] as IExchangeItem[],
	playerList: [] as IPlayerSearchResult[],
	playerIndex: 0,
	playerMaxIndex: 0,
	propertyListIndex: 0,
	propertyListMaxIndex: 0,
	finishScreenVisible: false,
	waitingForInvite: false,
};

const propertyExchangeSlice = createSlice({
	name: 'propertyExchange',
	initialState,
	reducers: {
		setSelectedPlayer: (state, action) => {
			state.selectedPlayer = action.payload;
		},
		setTabIndex: (state, action) => {
			let nextTabIndex = action.payload;
			if (state.tabsCount === 0) {
				nextTabIndex = -1;
			} else if (nextTabIndex < 0) {
				nextTabIndex = state.tabsCount - 1;
			} else if (nextTabIndex > state.tabsCount - 1) {
				nextTabIndex = 0;
			}
			state.tabIndex = nextTabIndex;
		},
		setTabsCount: (state, action) => {
			state.tabsCount = action.payload;
		},
		setPlayerOffer: (state, action) => {
			state.playerOffer = action.payload;
		},
		addPlayerOffer: (state, action: PayloadAction<IListItem>) => {
			const offer = state.playerOffer;
			offer.push(action.payload);
			state.playerOffer = offer;
		},
		setPlayerIndex: (state, action) => {
			state.playerIndex = action.payload;
		},
		setPlayerMaxIndex: (state, action) => {
			state.playerMaxIndex = action.payload;
		},
		setPropertyListIndex: (state, action) => {
			state.propertyListIndex = action.payload;
		},
		setPropertyListMaxIndex: (state, action) => {
			state.propertyListMaxIndex = action.payload;
		},
		setPlayerIndexPrev: (state) => {
			const index = state.playerIndex;
			state.playerIndex = index > 0 ? index - 1 : index;
		},
		setPlayerIndexNext: (state) => {
			const index = state.playerIndex;
			state.playerIndex = index < state.playerMaxIndex ? index + 1 : index;
		},
		setPropertyListIndexPrev: (state) => {
			const index = state.propertyListIndex;
			state.propertyListIndex = index > 0 ? index - 1 : index;
		},
		setPropertyListIndexNext: (state) => {
			const index = state.propertyListIndex;
			state.propertyListIndex =
				index < state.propertyListMaxIndex ? index + 1 : index;
		},
		setPlayerList: (state, action) => {
			state.playerList = action.payload;
		},
		setPropertyList: (state, action) => {
			state.propertyList = action.payload;
		},
		setFinishScreenVisible: (state, action) => {
			state.finishScreenVisible = action.payload;
		},
		setWaitingForInvite: (state, action) => {
			state.waitingForInvite = action.payload;
		},
	},
});

export const {
	setSelectedPlayer,
	setTabIndex,
	setTabsCount,
	setPlayerOffer,
	addPlayerOffer,
	setPlayerIndex,
	setPlayerMaxIndex,
	setPropertyListIndex,
	setPlayerIndexPrev,
	setPlayerIndexNext,
	setPropertyListIndexPrev,
	setPropertyListIndexNext,
	setPlayerList,
	setPropertyList,
	setPropertyListMaxIndex,
	setFinishScreenVisible,
	setWaitingForInvite,
} = propertyExchangeSlice.actions;

export default propertyExchangeSlice.reducer;
